import React from 'react';
import { Box, Container, Typography, Link, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { text: 'About Us', to: '/about' },
    { text: 'Terms of Service', to: '/terms' },
    { text: 'Contact', to: '/contact' }
  ];

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: theme.palette.mode === 'light' 
          ? theme.palette.grey[100] 
          : theme.palette.grey[900],
        borderTop: `1px solid ${theme.palette.divider}`
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', sm: 'flex-start' },
            gap: 2
          }}
        >
          {/* Links */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              gap: { xs: 1, sm: 3 }
            }}
          >
            {footerLinks.map((link, index) => (
              <Link
                key={link.text}
                component={RouterLink}
                to={link.to}
                color="text.secondary"
                sx={{
                  textDecoration: 'none',
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline'
                  }
                }}
              >
                {link.text}
              </Link>
            ))}
          </Box>

          {/* Copyright */}
          <Typography
            variant="body2"
            color="text.secondary"
            align={theme.breakpoints.down('sm') ? 'center' : 'right'}
          >
            &copy; {currentYear} InsiTech International. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
